import {NAVIGATION_CHANGE} from 'app/redux/constants/actionTypes';

const TITLE_PREFIX = 'کافه سینما';

const INITIAL_STATE = {
  title: TITLE_PREFIX,
  category: {
    slug: null,
    id: null
  },
  meta: {}
};

export default function navigation(state = INITIAL_STATE, action) {
  switch (action.type) {
    case NAVIGATION_CHANGE:
      const {title, ...payload} = action.payload;
      return {
        ...state,
        ...payload,
        title: title ? `${TITLE_PREFIX} | ${title}` : TITLE_PREFIX,
        path: window.location.pathname
      };
    default: 
      return state;
  }
}